import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";
import { TaskColumn, TaskSortValue } from "./task-view-enums";

export { TaskColumn, TaskSortValue };

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.NAME),
});
export type NameColumn = z.infer<typeof NameColumnSchema>;

const DueDateColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.DUE_DATE),
});
export type DueDateColumn = z.infer<typeof DueDateColumnSchema>;

const EstimateColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.ESTIMATE),
});
export type EstimateColumn = z.infer<typeof EstimateColumnSchema>;

const GroupColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.GROUP),
});
export type GroupColumn = z.infer<typeof GroupColumnSchema>;

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.ACTIONS),
});
export type ActionsColumn = z.infer<typeof ActionsColumnSchema>;

const EntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.ENTITIES),
});
export type EntitiesColumn = z.infer<typeof EntitiesColumnSchema>;

const AssigneeColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.ASSIGNEE),
});
export type AssigneeColumn = z.infer<typeof AssigneeColumnSchema>;

const StatusColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.STATUS),
});
export type StatusColumn = z.infer<typeof StatusColumnSchema>;

const PriorityColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.PRIORITY),
});
export type PriorityColumn = z.infer<typeof PriorityColumnSchema>;

const CreatedAtColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.CREATED_AT),
});
export type CreatedAtColumn = z.infer<typeof CreatedAtColumnSchema>;

const CreatedByColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.CREATED_BY),
});
export type CreatedByColumn = z.infer<typeof CreatedByColumnSchema>;

const UpdatedAtColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.UPDATED_AT),
});
export type UpdatedAtColumn = z.infer<typeof UpdatedAtColumnSchema>;

const CloseStageColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.CLOSE_STAGE),
});
export type CloseStageColumn = z.infer<typeof CloseStageColumnSchema>;

const CloseColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.CLOSE),
});
export type CloseColumn = z.infer<typeof CloseColumnSchema>;

const ServicePeriodColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.SERVICE_PERIOD),
});
export type ServicePeriodColumn = z.infer<typeof ServicePeriodColumnSchema>;

const VisibilityColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.VISIBILITY),
});
export type VisibilityColumn = z.infer<typeof VisibilityColumnSchema>;

const CompletedByColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.COMPLETED_BY),
});
export type CompletedByColumn = z.infer<typeof CompletedByColumnSchema>;

const CompletedAtColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.COMPLETED_AT),
});
export type CompletedAtColumn = z.infer<typeof CompletedAtColumnSchema>;

const ClientColumnSchema = ColumnSchema.extend({
    id: z.literal(TaskColumn.CLIENT),
});
export type ClientColumn = z.infer<typeof ClientColumnSchema>;

export const TaskViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.TASK),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            ActionsColumnSchema,
            DueDateColumnSchema,
            EstimateColumnSchema,
            GroupColumnSchema,
            EntitiesColumnSchema,
            AssigneeColumnSchema,
            PriorityColumnSchema,
            StatusColumnSchema,
            CreatedAtColumnSchema,
            CreatedByColumnSchema,
            UpdatedAtColumnSchema,
            CloseStageColumnSchema,
            CloseColumnSchema,
            ServicePeriodColumnSchema,
            VisibilityColumnSchema,
            CompletedByColumnSchema,
            CompletedAtColumnSchema,
            ClientColumnSchema,
        ]),
    ),
});

export type TaskView = z.infer<typeof TaskViewSchema>;
